const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/merchandiseAnalysis',
    name: 'MerchandiseAnalysis',
    component: layout,
    redirect: '/merchandiseAnalysis/index',
    meta: {
      title: '商品分析',
      i18Key: 'router.user.merchandiseAnalysis.title',
      roles: [1],
      category: 'insight',
    },
    sort: 54,
    children: [
      {
        path: 'index',
        name: 'MerchandiseAnalysisIndex',
        component: () => import('@/views/MerchandiseAnalysis/Index.vue'),
        meta: {
          title: '商品分析',
          i18Key: 'router.user.merchandiseAnalysis.index',
          roles: [1],
          headerConditions: ['brand', 'keyword', 'cycleType', 'location']
        }
      }
    ]
  }
]
export default routes
